import { sendEventToJumbo } from './jumbo';

export const MERCHANT_EVENTS = {
  GET_MERCHANT_DETAILS_SUCCESS: 'get_merchant_details_success',
  GET_MERCHANT_DETAILS_FAILURE: 'get_merchant_details_failure',
  GET_MERCHANT_HISTORY_SUCCESS: 'get_merchant_history_success',
  GET_MERCHANT_HISTORY_FAILURE: 'get_merchant_history_failure',
  GET_MERCHANT_NUMBER_SUCCESS: 'get_merchant_number_success',
  GET_MERCHANT_NUMBER_FAILURE: 'get_merchant_number_failure',
  MERCHANT_ALTERNATE_NUMBER_MODAL_OPEN: 'merchant_alternate_number_modal_open',
  MERCHANT_ALTERNATE_NUMBER_MODAL_CLOSE:
    'merchant_alternate_number_modal_close',
  MERCHANT_HISTORY_MODAL_OPEN: 'merchant_history_modal_open',
  MERCHANT_HISTORY_MODAL_CLOSE: 'merchant_history_modal_close',
  MERCHANT_TAG_DESCRIPTION_MODAL_OPEN: 'merchant_tag_description_modal_open',
  MERCHANT_TAG_DESCRIPTION_MODAL_CLOSE: 'merchant_tag_description_modal_close',
};

export const sendMerchantApiEvents = (eventName, orderId, customerId) => {
  sendEventToJumbo({
    eventName,
    orderId,
    customerId,
  });
};

export const sendMerchantModalEvents = (eventName, orderId, customerId) => {
  sendEventToJumbo({
    eventName,
    orderId,
    customerId,
  });
};
